import RootStore from './RootStore';
import { IListResult, IResult, IPerson} from '../global';
import relationApi from '../actions/relation';
import { observable, action } from 'mobx';

export default class RelationStore {
  @observable myself = {
    faceurl: '',
    id: '',
    name: '',
    status: '',
    total_gallery_image: 0,
    total_image: 0
  };

  @observable myselfAlbum = {
    data: [] as any[],
    total: 0
  };

  @observable person = {
    faceurl: '',
    id: 0,
    name: '',
    status: '',
    total_gallery_image: 0,
    total_image: 0
  } as IPerson;

  @observable personAlbum = {
    data: [],
    total: 0
  };

  @observable friends = [] as any[];

  @observable find = {
    faceurl: '',
    id: 0,
    name: '',
    status: '',
    total_gallery_image: 0,
    total_image: 0
  };

  @observable findAlbum = {
    data: [],
    total: 0
  };

  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }
  updateMyself(galleryid: string) {
    return relationApi.myself(galleryid).then(
      action((res: any) => {
        this.myself = {
          faceurl: res.faceurl,
          id: res.id,
          name: res.name,
          status: res.status,
          total_gallery_image: 0,
          total_image: 0
          // total_gallery_image: res.total_gallery_image || 0,
          // total_image: res.total_image || 0
        };
      })
    );
  }
  getMyselfAlbum(galleryid: string, page: number = 1) {
    let isPrivateGallery = false;
    if (window.dataDetail && window.dataDetail.privacy == 'private') {
      isPrivateGallery = true;
    }
    if (window.gallery.privacy == 'private') {
      isPrivateGallery = true;
    }

    return relationApi
      .myselfAlbum(isPrivateGallery ? galleryid : '', page)
      .then(
        action((res: IListResult) => {
          if (page == 1) {
            this.myselfAlbum = res;
          } else {
            let { data } = this.myselfAlbum;
            this.myselfAlbum = {
              data: { ...res.data, ...data },
              total: res.total
            };
          }

          // 把真实的全部数量更新到个人接口里，并且再算出来当前相册的张数
          this.myself.total_gallery_image = res.total;
          let targetGallery = this.myselfAlbum.data[window.gallery.id];
          if (
            targetGallery &&
            targetGallery.images &&
            targetGallery.images.length
          ) {
            this.myself.total_image = targetGallery.images.length;
            this.myself.total_gallery_image = Math.max(
              0,
              this.myself.total_gallery_image - this.myself.total_image
            );
          } else {
            this.myself.total_image = 0;
          }

          // 必须返回{total:全部数量， data:全部数据}否则会导致加载更多有效BUG
          // 这个接口比较特殊，用data===[]来判断 没有新的数据了

          // 更新一下水印信息
          // if (res && res.data && Object.keys(res.data).length > 0) {
          //   Object.keys(res.data).map(galleryid => {
          //     let gallery = res.data[Number(galleryid)];
          //     if (gallery && gallery.watermarks) {
          //       this.rootStore.galleryStore.setWatermarksByKey(
          //         galleryid,
          //         gallery.watermarks
          //       );
          //     }
          //   });
          // }
          if (res && res.watermarks) {
            Object.keys(res.watermarks).map(galleryid => {
              let marks = res.watermarks[Number(galleryid)];
              this.rootStore.galleryStore.setWatermarksByKey(galleryid, marks);
            });
          }

          return this.myselfAlbum;
        })
      );
  }

  @action clearCurrentPerson() {
    this.person = {
      faceurl: '',
      id: 0,
      name: '',
      status: '',
      total_gallery_image: 0,
      total_image: 0
    };
    this.personAlbum = {
      data: [],
      total: 0
    };
  }

  @action clearMyself() {
    this.myself = {
      faceurl: '',
      id: '',
      name: '',
      status: '',
      total_gallery_image: 0,
      total_image: 0
    };
    this.myselfAlbum = {
      data: [],
      total: 0
    };
  }

  @action clearFind() {
    this.find = {
      faceurl: '',
      id: 0,
      name: '',
      status: '',
      total_gallery_image: 0,
      total_image: 0
    };
    this.findAlbum = {
      data: [],
      total: 0
    };
  }

  @action setPerson(person:IPerson) {
    this.person = person;
  }

  getPerson(
    galleryid: string,
    personid: number,
    imageid?: number,
    openid?: string,
    faceurl?: string,
  ) {
    return relationApi.person(galleryid, personid, imageid, openid).then(
      action((res: any) => {
        this.person = {
          ...this.person,
          faceurl: faceurl ? faceurl : res.faceurl,
          id: res.id,
          name: res.name,
          status: res.status
        };
      })
    );
  }

  getFind(
    galleryid: string,
    personid: number,
    imageid?: number,
    openid?: string,
    faceurl?: string,
  ) {
    return relationApi.person(galleryid, personid, imageid, openid).then(
      action((res: any) => {
        this.find = {
          ...this.find,
          faceurl: faceurl ? faceurl : res.faceurl,
          id: res.id,
          name: res.name,
          status: res.status
        };
      })
    );
  }

  getFindPeopleAlbum(galleryid: string, personid: number, page: number = 1) {
    let isPrivateGallery = true;

    return relationApi
      .personAlbum(isPrivateGallery ? galleryid : '', personid, page)
      .then(
        action((res: any) => {
          if (page == 1) {
            this.findAlbum = res;
          } else {
            let { data } = this.findAlbum;
            this.findAlbum = {
              data: data.concat(res.data),
              total: res.total
            };
          }

          this.find.total_gallery_image = res.total;
          let targetGallery = this.findAlbum.data[window.gallery.id] as any;
          if (
            targetGallery &&
            targetGallery.images &&
            targetGallery.images.length
          ) {
            this.find.total_image = targetGallery.images.length;
          } else {
            this.find.total_image = 0;
          }

          if (res && res.watermarks) {
            Object.keys(res.watermarks).map(galleryid => {
              let marks = res.watermarks[Number(galleryid)];
              this.rootStore.galleryStore.setWatermarksByKey(galleryid, marks);
            });
          }
        })
      );
  }

  getPersonAlbum(galleryid: string, personid: number, page: number = 1) {
    // let isPrivateGallery = false;
    // if (window.dataDetail && window.dataDetail.privacy == 'private') {
    //   isPrivateGallery = true;
    // }
    // if (window.gallery.privacy == 'private') {
    //   isPrivateGallery = true;
    // }
    let isPrivateGallery = true;

    return relationApi
      .personAlbum(isPrivateGallery ? galleryid : '', personid, page)
      .then(
        action((res: any) => {
          // 需要对数据做一下排序，提前排序一下，免得到Observer那里去了
          if(res && res.data) {
            Object.keys(res.data).forEach((key: string, index: number)=>{
              let gallery = res.data[key];
              if(gallery && gallery.images) {
                res.data[key].images.sort((a: any, b: any) => {
                  return b.id - a.id;
                });
              }
            });
          }

          if (page == 1) {
            this.personAlbum = res;
          } else {
            let { data } = this.personAlbum;
            this.personAlbum = {
              data: data.concat(res.data),
              total: res.total
            };
          }

          // 把真实的全部数量更新到个人接口里，并且再算出来当前相册的张数
          this.person.total_gallery_image = res.total;
          let targetGallery = this.personAlbum.data[window.gallery.id] as any;
          if (
            targetGallery &&
            targetGallery.images &&
            targetGallery.images.length
          ) {
            this.person.total_image = targetGallery.images.length;
            // this.person.total_gallery_image = Math.max(
            //   0,
            //   this.person.total_gallery_image - this.person.total_image
            // );
          } else {
            this.person.total_image = 0;
          }

          // 更新一下水印信息
          // if (res && res.data && Object.keys(res.data).length > 0) {
          //   Object.keys(res.data).map(galleryid => {
          //     let gallery = res.data[galleryid];
          //     if (gallery && gallery.watermarks) {
          //       this.rootStore.galleryStore.setWatermarksByKey(
          //         galleryid,
          //         gallery.watermarks
          //       );
          //     }
          //   });
          // }
          if (res && res.watermarks) {
            Object.keys(res.watermarks).map(galleryid => {
              let marks = res.watermarks[Number(galleryid)];
              this.rootStore.galleryStore.setWatermarksByKey(galleryid, marks);
            });
          }

          if(res && res.gallerys) {
            Object.keys(res.gallerys).map(galleryid => {
              let marks = res.gallerys[Number(galleryid)];
              this.rootStore.pagedataStore.setGallery(galleryid, marks);
            });
          }
        })
      );
  }
  follower() {
    return relationApi.follower().then(
      action((res: any) => {
        this.friends = res;
      })
    );
  }
  @action deleteFollower(id:number) {
    if(id) {
      this.friends = this.friends.filter((it:any)=>{
        if(it && it.personid == id) {
          return false;
        }
        return true;
      });
    }
  }
}
